import jQuery from "jquery";

jQuery(function ($) {
  addAccessibilitySubmenuButtons();
  accessibleMobileMenuHandler();
  showMenuOnScrollTop();

  // Ajoute des boutons accessibles qui ouvrent les sous-menu mobile
  // Code inspiré de W3.org et converti en jquery: https://www.w3.org/WAI/tutorials/menus/flyout/
  function addAccessibilitySubmenuButtons() {
    const menuItems = $(".main-navigation li.menu-item-has-children");
    menuItems.each(function (index, element) {
      const link = $(element).children("a");
      
      const button =
      '<button class="submenu-mobile-button" type="button" aria-haspopup="true" aria-expanded="false">' +
      '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M13.0306 6.53074L8.53063 11.0307C8.38973 11.1716 8.19863 11.2508 7.99938 11.2508C7.80012 11.2508 7.60902 11.1716 7.46813 11.0307C7.32723 10.8898 7.24807 10.6987 7.24807 10.4995C7.24807 10.3002 7.32723 10.1091 7.46813 9.96824L10.6875 6.75011H1.5C1.30109 6.75011 1.11032 6.67109 0.96967 6.53044C0.829018 6.38979 0.75 6.19902 0.75 6.00011C0.75 5.8012 0.829018 5.61043 0.96967 5.46978C1.11032 5.32913 1.30109 5.25011 1.5 5.25011H10.6875L7.46937 2.03011C7.32848 1.88921 7.24932 1.69812 7.24932 1.49886C7.24932 1.2996 7.32848 1.10851 7.46937 0.967609C7.61027 0.826713 7.80137 0.747559 8.00062 0.747559C8.19988 0.747559 8.39098 0.826713 8.53187 0.967609L13.0319 5.46761C13.1018 5.53738 13.1573 5.62028 13.1951 5.71155C13.2329 5.80281 13.2523 5.90065 13.2522 5.99943C13.252 6.09822 13.2324 6.19601 13.1944 6.28718C13.1564 6.37836 13.1007 6.46113 13.0306 6.53074Z" fill="#0C0C0C"/>' +
      "</svg>" +
      '<span class="screen-reader-text">ouvrir le sous-menu de “' +
      link.text() +
      "”</span></button>";
      link.after(button);
      
      let underlink = '<li class="menu-item main-menu-item only-mobile">';
      if( link.attr('href') != undefined ){
        underlink += '<a href="'+ link.attr('href') +'">';
      } else {
        underlink += '<a aria-haspopup="true" aria-expanded="false">';
      }
      underlink += link.text() +
      "</a>" +
      "</li>";
      $(element).children("ul").children("li:nth-child(2)").before(underlink);

      $(element)
        .children("button")
        .on("click", function (event) {
          // const parentLi = $(element);
          // if (parentLi.hasClass("is-opened")) {
          //   parentLi.removeClass("is-opened");
          //   link.attr("aria-expanded", "false");
          //   $(this).attr("aria-expanded", "false");
          // } else {
          //   parentLi.addClass("is-opened");
          //   link.attr("aria-expanded", "true");
          //   $(this).attr("aria-expanded", "true");
          // }

          event.preventDefault();

          $(this).next().addClass('open');
        });

      $(link)
        .on("click", function (event) {
          if($(this).next().is(':visible')){
            // On mobile only
            event.preventDefault();
            $(this).next().next().addClass('open');
          }
        });
    });

    $('.main-navigation.main-navigation-ul').on('click', '.c-drilldown-back', function () {
      $(this).closest('.sub-menu.open').removeClass('open');
    });
  }

  // Fonction qui gère l'ouverture du menu mobile de façon accessible
  function accessibleMobileMenuHandler() {
    const toggleButton = $(".main-navigation #toggle-menu-button");
    const navigationContainer = $(".main-navigation .main-navigation-ul");
    const anchorLinks = navigationContainer.find("a[href='#finder']");
    toggleButton.on("click", function (event) {
      toggleMenu(toggleButton, navigationContainer);
      event.preventDefault();
    });
    navigationContainer.find("a,button").on("keydown", function (event) {
      if (event.which == 27 && toggleButton.attr("aria-expanded") == "true") {
        toggleMenu(toggleButton, navigationContainer);

        event.preventDefault();
      }
    });
    if (anchorLinks.length){
      anchorLinks.on("click", function (event) {
        toggleMenu(toggleButton, navigationContainer);
      });
    }
    
  }

  function toggleMenu(toggleButton, navigationContainer) {
    const body = $("body");
    const isOpen = toggleButton.attr("aria-expanded") == "true" ? true : false;
    if (isOpen) {
      toggleButton.attr("aria-expanded", "false");
      navigationContainer.removeClass("is-opened");
      body.removeClass("mobile-menu-opened");
      $('.main-navigation.main-navigation-ul .sub-menu.open').removeClass('open');
    } else {
      toggleButton.attr("aria-expanded", "true");
      navigationContainer.addClass("is-opened");
      body.addClass("mobile-menu-opened");
    }
  }

  // Permet d'afficher le menu au scroll vers le haut.
  function showMenuOnScrollTop() {
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $(".header-container").outerHeight();
    $(window).on("scroll", function (event) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(window).scrollTop();
      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) return;

      if (st < navbarHeight) {
        $(".header").removeClass("is-smaller");
      } else {
        $(".header").addClass("is-smaller");
      }
      // setTimeout(function () {
      //   addTopBarsSizeCSSVariable(null, true);
      // }, 305);

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $(".header").removeClass("nav-down").addClass("nav-up");
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $(".header").removeClass("nav-up").addClass("nav-down");
        }
      }

      lastScrollTop = st;
    }
  }
});
